module.exports = __webpack_public_path__ + "static/media/edutrea.65b5fd25.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/edutrea.png
// module id = 399
// module chunks = 0